import React, { useState, useEffect, useCallback } from "react";

import { API } from "./../../config/api";
import AOS from "aos";
import "aos/dist/aos.css";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
import VerticalAds from "../../Admin/Pages/VerticleAds";

export default function Hiring() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);

  /* =========================
      STATES
  ========================= */

  const [hiringList, setHiringList] = useState([]);

  const [searchName, setSearchName] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchCity, setSearchCity] = useState("");

  const [searchMobile, setSearchMobile] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage, setItemsPerPage] = useState(40);

  /* =========================
      FETCH HIRING
  ========================= */

  const fetchHiring = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API.GET_ACTIVE_HIRING}&t=${Date.now()}`);

      const data = await res.json();

      if (data.success) {
        setHiringList(data.data || []);
      } else {
        setHiringList([]);
      }
    } catch (error) {
      console.log(error);
      setHiringList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHiring();

    const interval = setInterval(fetchHiring, 5000);

    window.addEventListener("focus", fetchHiring);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", fetchHiring);
    };
  }, [fetchHiring]);

  /* =========================
      FILTER
  ========================= */

  const filteredHiring = hiringList.filter((item) => {
    const matchesName = item.name
      ?.toLowerCase()
      .includes(searchName.toLowerCase());

    const matchesCity = item.address
      ?.toLowerCase()
      .includes(searchCity.toLowerCase());

    const matchesMobile = item.mobile
      ?.toLowerCase()
      .includes(searchMobile.toLowerCase());

    return matchesName && matchesCity && matchesMobile;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchName, searchCity, searchMobile, itemsPerPage]);

  /* =========================
      PAGINATION
  ========================= */

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentHiring = filteredHiring.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredHiring.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getPagination = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    pages.push(1);

    let start = Math.max(2, currentPage - 1);

    let end = Math.min(totalPages - 1, currentPage + 1);

    if (currentPage <= 3) {
      start = 2;
      end = 5;
    }

    if (currentPage >= totalPages - 2) {
      start = totalPages - 4;
      end = totalPages - 1;
    }

    if (start > 2) {
      pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages;
  };
  if (loading) {
    return (
      <div className="hiring-loading-container">
        <div className="hiring-loader">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>

          <h5 className="mt-3 mb-1">Loading Hiring Opportunities...</h5>

          <p className="text-muted mb-0">
            Please wait while we fetch the latest opportunities.
          </p>
        </div>
      </div>
    );
  }
  /* =========================
      PART 2 BELOW
  ========================= */

  return (
    <div className="shop-page container-fluid py-4">
      <div className="row">
        {/* LEFT FILTER */}
        <div className="col-lg-2 d-none d-lg-block" data-aos="fade-right">
          <div className="filter-sidebar shadow-sm p-3 bg-white rounded sticky-top">
            {/* <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Filters</h5>
              <button
                className="btn btn-sm text-danger p-0"
                onClick={() => {
                  setSearchName("");
                  setSearchCity("");
                  setSearchMobile("");
                }}
                style={{ fontSize: "0.8rem", fontWeight: "600" }}
              >
                CLEAR ALL
              </button>
            </div> */}
            <div className="d-flex justify-content-between align-items-center mb-4 filter-header-border">
              <h5 className="mb-0 fw-bold text-secondary text-uppercase tracking-wider fs-6">
                Filters
              </h5>
              <button
                className="btn-uniq-reset"
                onClick={() => {
                  setSearchName("");
                  setSearchCity("");
                  setSearchMobile("");
                }}
              >
                Clear All
              </button>
            </div>

            <div className="filter-box mt-4">
              <h6>Hiring Name</h6>

              <input
                type="text"
                className="form-control"
                placeholder="Search Hiring"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              />
            </div>

            <div className="filter-box mt-4">
              <h6>Address</h6>

              <input
                type="text"
                className="form-control"
                placeholder="Search Address"
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
              />
            </div>

            <div className="filter-box mt-4">
              <h6>Mobile</h6>

              <input
                type="text"
                className="form-control"
                placeholder="Search Mobile"
                value={searchMobile}
                onChange={(e) => setSearchMobile(e.target.value)}
              />

              {/* <button
                className="btn btn-sm btn-link mt-2 p-0"
                onClick={() => {
                  setSearchName("");
                  setSearchCity("");
                  setSearchMobile("");
                }}
              >
                Clear All
              </button> */}
            </div>
            <div className="sidebar-ad">
              <div className="small text-center fw-bold p-1">SPONSORED</div>

              <VerticalAds />
            </div>
          </div>
        </div>

        {/* MOBILE FILTER */}

        <div className="d-lg-none mb-3">
          <div className="mobile-filter-bar">
            <input
              className="mobile-search"
              placeholder="Hiring Name"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />

            <input
              className="mobile-search"
              placeholder="Address"
              value={searchCity}
              onChange={(e) => setSearchCity(e.target.value)}
            />

            <input
              className="mobile-search"
              placeholder="Mobile"
              value={searchMobile}
              onChange={(e) => setSearchMobile(e.target.value)}
            />
          </div>
        </div>

        {/* CONTENT */}

        <div className="col-lg-10">
          <div
            className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2"
            data-aos="fade-down"
          >
            <h2 className="section-title mb-0">Hiring Opportunities</h2>

            <div className="d-flex align-items-center gap-2">
              <select
                className="form-select form-select-sm"
                style={{ width: "80px" }}
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={40}>40</option>
                <option value={60}>60</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>

          {/* Cards */}

          <div className="hiring-list">
            {currentHiring.length > 0 ? (
              currentHiring.map((item, index) => (
                <div className="hiring-card-horizontal">
                  {/* First Row */}
                  <div className="hiring-top">
                    <div className="hiring-user-info">
                      <div className="hiring-name">
                        <i className="bi bi-person-workspace me-2"></i>
                        <strong>{item.name}</strong>
                      </div>

                      <div className="hiring-mobile">
                        <i className="bi bi-telephone-fill me-2"></i>
                        {item.mobile}
                      </div>
                    </div>

                    <div className="hiring-date">
                      <i className="bi bi-calendar-event me-2"></i>
                      {item.created_at
                        ? new Date(item.created_at).toLocaleDateString(
                            undefined,
                            {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            },
                          )
                        : "-"}
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="hiring-address">
                    <strong>Address :</strong> {item.address}
                  </div>

                  {/* Third Row */}
                  <div className="hiring-details">
                    <strong>Details :</strong> {item.details}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center w-100 py-5">
                <p className="text-muted">No Hiring Advertisements Found.</p>
              </div>
            )}
          </div>
          {/* Pagination */}

          <div className="d-flex justify-content-center mt-5">
            <ul className="pagination uniq-pagination-wrapper shadow-sm p-1 rounded-pill bg-white">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link rounded-pill"
                  onClick={() => paginate(currentPage - 1)}
                >
                  &lsaquo; Previous
                </button>
              </li>

              {getPagination().map((page, index) =>
                page === "..." ? (
                  <li key={`dots-${index}`} className="page-item disabled">
                    <span className="page-link border-0 bg-transparent">
                      ...
                    </span>
                  </li>
                ) : (
                  <li
                    key={page}
                    className={`page-item ${
                      currentPage === page ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link rounded-circle"
                      onClick={() => paginate(page)}
                    >
                      {page}
                    </button>
                  </li>
                ),
              )}

              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link rounded-pill"
                  onClick={() => paginate(currentPage + 1)}
                >
                  Next &rsaquo;
                </button>
              </li>
            </ul>
          </div>
          <HorizontalAds />
        </div>
      </div>

      <style>{`
    .custom-pagination .page-link {
      color: #00a699;
      border: 1px solid #dee2e6;
      margin: 0 3px;
      border-radius: 4px;
      font-weight: 500;
    }

    .custom-pagination .page-item.active .page-link {
      background-color: #00a699;
      border-color: #00a699;
      color: white;
    }

    .custom-pagination .page-link:hover {
      background-color: #f1f1f1;
      color: #00847a;
    }
  `}</style>
    </div>
  );
}
